export default __webpack_public_path__ + "static/media/DuitNowQR.9adaed6e.png";